import React from "react";
import DetailComment from "./DetailComment";

const GalleryComment = (props) => {
  const [state, setState] = React.useState({
    ShowMore: true,
    selectedcomment: {},
  });
  const showComment = (comment) => {
    setState({ ...state, ShowMore: !state.ShowMore, selectedcomment: comment });
  };
  return (
    <>
      {state.ShowMore ? (
        <div className='GalleryComment'>
          {props.comments.map((comment) => (
            <div className='GalleryImg' onClick={() => showComment(comment)}>
              <img src={comment.images[0]} alt='pic' />
            </div>
          ))}
        </div>
      ) : (
        <DetailComment comment={state.selectedcomment} />
      )}
    </>
  );
};

export default GalleryComment;
